import { render } from "./AccordionsPage.vue?vue&type=template&id=4a013fec&ts=true"
import script from "./AccordionsPage.vue?vue&type=script&lang=ts"
export * from "./AccordionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__